import moment from 'moment';

export function scrollToSection (selector) {
  const img = document.querySelector(selector)
  const top = img.offsetTop
  window.scrollTo({
    top,
    behavior: 'smooth'
  })
}

export function sortProgramsByDate (a, b) {
  const date1 = new Date(a.dateTime)
  const date2 = new Date(b.dateTime)

  if (date2.getTime() > date1.getTime()) {
    return -1
  } else if (date2.getTime() < date1.getTime()) {
    return 1
  } else {
    return 0
  }
}

function getDateTime(dateTime) {
  moment.locale('hu')
  const [_, timeDate] = dateTime.split('T')
  const momentDate = moment(dateTime)
  const dateYear = momentDate.year()
  const dateDay = momentDate.date()
  const dateMonth = momentDate.month()
  const day = `${moment.months(dateMonth)} ${dateDay}`
  const time = timeDate.substr(0, 5)
  const hour = momentDate.hour()
  return {day, time, hour}
}

export function reducePrograms (acc, curr) {
  const { day, time, hour } = getDateTime(curr.dateTime)
  const endDate = curr.endTime && getDateTime(curr.endTime)
  const endTime = endDate && endDate.time


  const currentData = {
    time,
    endTime,
    title: curr.title,
    description: curr.description,
    company: curr.company
  }

  if (curr.hasOwnProperty('companyUrl')) {
    currentData['companyUrl'] = `/company/${curr.companyUrl}`
  }

  if (curr.hasOwnProperty('type')) {
    currentData['type'] = curr.type
  }

  if (day in acc) {
    if (hour in acc[day]) {
      acc[day][hour].push(currentData)
    } else {
      acc[day][hour] = [currentData]
    }
  } else {
    acc[day] = {
      [hour]: [currentData]
    }
  }

  return acc
}

export function getTheme(year) {
  switch (year) {
    case '2019':
      return {
        colorA: '#e63d2a',
        colorB: '#1e5a9e'
      }
    case '2020':
      return {
        colorA: '#e63312',
        colorB: '#009f94'
      }
    default:
      return;
  }
}
